import {Module} from 'vuex';
import {RootState} from '@/store';
import FlexGridModel from '@/models/FlexGridModel';
import FlexGridSortingTypeEnum from '@/enums/FlexGridSortingTypeEnum';
import {
    SET_COMPRESSED,
    SET_DATA,
    SET_EDITING_TO_SHOW_ONLY_VISIBLE_COLUMNS,
    SET_IS_EDITABLE,
    SET_LOCAL_ID_GRID_CONFIG_ITEM,
    SET_SELECTED_LIST,
    SET_SORT_INDEX,
    SET_SORT_KEY,
    SET_SORT_TYPE,
    SET_SORTED_DATA,
    SET_TRANSPOSE,
    SET_TRANSPOSE_LOADING,
    UPDATE_CONFIG,
    UPDATE_CONFIGS,
    UPDATE_IMPORT_CONFIGS,
} from '@/store/modules/flexGridModule/flexGrid-mutation-types';

type FlexGridState = {
    data: FlexGridModel | null;
    sortKey: string | null;
    sortType: FlexGridSortingTypeEnum;
    sortIndex: number | null;
    compressed: boolean | undefined;
    localIdGridConfigItem: number | undefined;
    sortedData: FlexGridModel | null;
    transpose: boolean;
    transposeLoading: boolean;
    selectedList: number[];
    isEditable: boolean;
    editingToShowOnlyVisibleColumns: boolean;
};

const FlexGridModule: Module<FlexGridState, RootState> = {
    namespaced: true,
    state: () => ({
        data: null,
        sortKey: null,
        sortType: FlexGridSortingTypeEnum.Up,
        sortIndex: null,
        compressed: undefined,
        localIdGridConfigItem: undefined,
        sortedData: null,
        transpose: false,
        transposeLoading: false,
        selectedList: [],
        isEditable: false,
        editingToShowOnlyVisibleColumns: false,
    }),
    mutations: {
        [SET_DATA]: (state, data) => (state.data = data),
        [SET_SORT_KEY]: (state, key) => (state.sortKey = key),
        [SET_SORT_INDEX]: (state, index) => (state.sortIndex = index),
        [SET_SORT_TYPE]: (state, type) => (state.sortType = type),
        [SET_COMPRESSED]: (state, bool) => (state.compressed = bool),
        [SET_LOCAL_ID_GRID_CONFIG_ITEM]: (state, id) => (state.localIdGridConfigItem = id),
        [SET_SORTED_DATA]: (state, data) => (state.sortedData = data),
        [UPDATE_CONFIGS]: (state, configs) => {
            if (state.data) state.data.Config.Configs = configs;
        },
        [UPDATE_IMPORT_CONFIGS]: (state, configs) => {
            if (state.data) state.data.Config.ConfigImports = configs;
        },
        [UPDATE_CONFIG]: (state, config) => {
            if (state.data) state.data.Config = config;
        },
        [SET_TRANSPOSE]: (state, bool) => (state.transpose = bool),
        [SET_TRANSPOSE_LOADING]: (state, bool) => (state.transposeLoading = bool),
        [SET_SELECTED_LIST]: (state, list) => (state.selectedList = list),
        [SET_IS_EDITABLE]: (state, bool) => (state.isEditable = bool),
        [SET_EDITING_TO_SHOW_ONLY_VISIBLE_COLUMNS]: (state, bool) => (state.editingToShowOnlyVisibleColumns = bool),
    },
    getters: {
        groupColspan: state => {
            return state.data?.Columns.reduce((summ, current) => (summ += current.ColSpan), 0);
        },
        hasSubcomponents: state => {
            return !!state.data?.Config.HasSubcomponents;
        },
        emptyCellsCount: state => {
            if (state.data) {
                return state.data.Config.GroupCount + Number(state.data.Config.HasSubcomponents);
            } else return 0;
        },
        isCanTranspose: state => state.data?.Config.IsOrderable && state.data?.Config.GroupCount <= 0,
    },
    actions: {},
};

export default FlexGridModule;
